<template>
  <div class="main-container myorder deposit mt30">
<!--        <code>    {{  job_type }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">

        <div class="col-md-12">
          <div>
            <div class="income_summary affiliate full animated slideInUp">
              <img src="@/assets/images/baloon.png" class="leftbg" alt="alt">
              <br/>
              <div>
                <p class="deposit-title center-text"><b>Open Jobs</b></p>
                <ul class="lists">
                  <li>Refer Your family member &amp; friends</li>
                  <li>Request Them to Oder from Gopalganjbazar.com online shop</li>
                  <li>If they Order More than <b>499 Taka</b> you will get <b>40 Taka</b> gift as deposit money</li>
                  <li>You can use this money for purchase product from Gopalganjbazar.com</li>
                  <li>You will get gift money once for each Unique customer join with us.</li>
                  <li>Refer More and get more Deposit Gift</li>
                  <li>Condition applied</li>
                </ul>
                <div class="row jobs">

                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="realtive-area">
                        <label class="inputLabel">আপনার পুরো নাম  *</label>
                        <input type="text" v-model="full_name" placeholder="আপনার পুরো নাম লিখুন "
                               class="form-control"></div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <div class="realtive-area">
                        <label class="inputLabel">আপনার ফোন নম্বর  *</label>
                        <input type="text" v-model="phone" placeholder="আপনার ফোন নম্বর লিখুন"
                               class="form-control"></div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <div class="realtive-area">
                        <label class="inputLabel">আপনার ইমেইল এড্রেস  (ঐচ্ছিক)</label>
                        <input type="text" v-model="email" placeholder="আপনার ইমেইল এড্রেস  লিখুন"
                               class="form-control"></div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="realtive-area">
                        <label class="inputLabel">আপনি কি পদে আবেদন করতে চান  *</label>
                        <div class="payment-options">
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" v-model="job_type" name="type1"
                                     id="type1" value="রাইডার"> <label
                              for="type1">রাইডার</label>
                            </div>
                          </div>
                          <div class="each-option">
                            <div  class="radio radio-success">
                              <input type="radio" name="type2" v-model="job_type"
                                     id="type2" value="মার্কেটিং জব"> <label
                              for="type2">মার্কেটিং জব </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="realtive-area">
                        <label class="inputLabel">শিক্ষাগত যোগ্যতা *
                        </label>
                        <div class="payment-options">
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="edu1" v-model="education"
                                     id="edu1" value="এসএসসি"> <label
                              for="edu1">এসএসসি  </label>
                            </div>
                          </div>
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="edu2" v-model="education"
                                     id="edu2" value="এইচএসসি"> <label
                              for="edu2">এইচএসসি</label>
                            </div>
                          </div>
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="edu3" v-model="education"
                                     id="edu3" value="স্নাতক ডিগ্রি"> <label
                              for="edu3">স্নাতক ডিগ্রি </label>
                            </div>
                          </div>

                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="edu4" v-model="education"
                                     id="edu4" value="লিখতে পড়তে পারি"> <label
                              for="edu4">লিখতে পড়তে পারি</label>
                            </div>
                          </div>
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="edu5" v-model="education"
                                     id="edu5" value="নেই"> <label
                              for="edu5">নেই </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="realtive-area">
                        <label class="inputLabel">কাজের ধরণ *
                        </label>
                        <div class="payment-options">
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="jb_type1" v-model="job_time"
                                     id="jb_type1" value="ফুল টাইম"> <label
                              for="jb_type1">ফুল টাইম   </label>
                            </div>
                          </div>
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="jb_type2" v-model="job_time"
                                     id="jb_type2" value="হাফ  টাইম "> <label
                              for="jb_type2">হাফ  টাইম </label>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="realtive-area">
                        <div  v-if="job_type == 'রাইডার'">
                        <label class="inputLabel">আপনার যানবাহনের ধরণ *
                        </label>
                        <div class="payment-options">
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="vehicle" v-model="vehicle"
                                     id="vehicle1" value="সাইকেল"> <label
                              for="vehicle1">সাইকেল </label>
                            </div>
                          </div>
                          <div class="each-option">
                            <div class="radio radio-success">
                              <input type="radio" name="vehicle" v-model="vehicle"
                                     id="vehicle2" value="মোটরবাইক"> <label
                              for="vehicle2">মোটরবাইক</label>
                            </div>
                          </div>

                        </div>
                        </div>
                        <div class="payment-options">
                             <br>
                          <div class="each-option" >
                            <div class="checkbox checkbox-success">
                              <input type="checkbox" name="chk1" v-model="accept"
                                     id="chk1" value="4"> <label
                              for="chk1">আমি এখানে বলা প্রত্যেকটি তথ্য সঠিক , আমি সম্মতি দিচ্ছি যে আপনি আমার সরবরাহিত তথ্য সংগ্রহ ও ব্যবহার এবং প্রকাশ করতে পারেন।</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div><br>
                <div class="text-center">
                  <button class="btn btn-base orderCompleteBtn jobBtn " @click="">Apply Job</button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
const $ = require('jquery');
window.$ = $;
$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 50);
    });

});
import axios from 'axios';

export default {
  data() {
    return {
      message_en: null,
      message_bn: null,
      user_id: null,
      phone: null,
      message: null,
      email: null,
      job_type: null,
      education: null,
      job_time: null,
      vehicle: null,
      full_name: null,
      response_message: null,
      accept: null,
      customers: []
    };
  },
  created: function () {
    if (localStorage.getItem("userinfo")) {
      this.user_id = JSON.parse(localStorage.getItem("userinfo")).id;
    }
    this.deposit_message();
    this.deposit_list();
  },
  methods: {
    applyJob: function () {
      let vm = this;
      if (this.full_name && this.phone && this.email && this.job_type && this.job_time && this.education && this.accept) {
        if (this.phone) {
          let check = this.phone.match(/^(01[3456789])(\d{8})$/);
          if (check == null) {
            alert('Phone Number Invalid');
          } else {
          }
        }
      }
      }
  }
};
</script>
